import { useCallback, useState } from "react";
import { useDigitalLite } from "./api/use-digital-lite";
import { useChangeDigitalLite } from "./api/use-change-digital-lite";

export const useDigitalLiteModal = (codingWipKey, saveCodingWipKey = false, onCloseCallback, sourcePage) => {
    const [reason, setReason] = useState();
    const [showSwitchModal, setSwitchModal] = useState(false);
    const { data: reasonOptions } = useDigitalLite();
    const { mutate: changeDigitalToDigitalLite, isLoading } = useChangeDigitalLite(sourcePage);

    const handleReason = useCallback((newReason) => setReason(newReason), []);

    const handleSwitchModal = useCallback((isOpen) => {
        setSwitchModal(isOpen);

        if (onCloseCallback && !isOpen) {
            onCloseCallback();
        }
    }, []);

    const handleChangeDigitalToDigitalLite = useCallback(async () => {
        const changeReason = reasonOptions.find(({ value }) => value === parseInt(reason));

        await changeDigitalToDigitalLite(
            { codingWipKey, changeReason },
            {
                onSuccess: ({ newShipmentKey }) => {
                    if (saveCodingWipKey) {
                        localStorage.setItem("newProfilingCodingWipKey", newShipmentKey);
                    }

                    window.location.reload();
                },
            }
        );
    }, [codingWipKey, reasonOptions, reason]);

    return {
        setSwitchReason: handleReason,
        openModal: handleSwitchModal,
        switchDigitalToDigitalLite: handleChangeDigitalToDigitalLite,
        reasonOptions,
        reason,
        isLoading,
        showSwitchModal,
    };
};
